export interface WorkoutTimeBounds {
  firstSetAt: string | Date | null | undefined;
  finalSetAt: string | Date | null | undefined;
}

function milliseconds(value: string | Date | null | undefined) {
  if (!value) return null;
  const result = new Date(value).getTime();
  return Number.isFinite(result) ? result : null;
}

/** Whole seconds from the first completed set through the final completed set. */
export function workoutDurationSeconds(bounds: WorkoutTimeBounds) {
  const first = milliseconds(bounds.firstSetAt);
  const final = milliseconds(bounds.finalSetAt);
  if (first === null || final === null) return 0;
  return Math.max(0, Math.round((final - first) / 1000));
}

/** Sum training spans on each local calendar day, excluding overnight resume gaps. */
export function trainingDurationSeconds(timestamps: Array<string | Date>, timezone: string, now?: string | Date) {
  const days = new Map<string, number[]>();
  const format = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year:'numeric', month:'2-digit', day:'2-digit' });
  for(const timestamp of timestamps) {
    const value=milliseconds(timestamp); if(value===null) continue;
    const key=format.format(new Date(value)); const list=days.get(key)??[]; list.push(value); days.set(key,list);
  }
  const current=milliseconds(now);
  if(current!==null) days.get(format.format(new Date(current)))?.push(current);
  return [...days.values()].reduce((sum,values)=>sum+Math.max(0,Math.round((Math.max(...values)-Math.min(...values))/1000)),0);
}

export function completedSetTimeBounds(
  completedAt: Array<string | Date>,
  isComplete: boolean,
) {
  const values = completedAt
    .map(milliseconds)
    .filter((value): value is number => value !== null)
    .sort((left, right) => left - right);
  if (!values.length)
    return { firstSetAt: null, finalSetAt: null, elapsedSeconds: null };
  const firstSetAt = new Date(values[0]);
  const finalSetAt = isComplete ? new Date(values.at(-1)!) : null;
  return {
    firstSetAt,
    finalSetAt,
    elapsedSeconds: finalSetAt
      ? workoutDurationSeconds({ firstSetAt, finalSetAt })
      : null,
  };
}
